module.exports = __webpack_public_path__ + "img/film-threat-cover.62266756.jpg";